import { z } from 'zod'

export const UserEditSchema = z.object({
  description: z.string().trim().min(1, 'Введите имя, фамилию'),
  login: z
    .string()
    .trim()
    .min(1, 'Введите логин')
    .transform((val) => val.replace(/\D/g, ''))
    .refine((val) => /^375[1-9]\d{8}$/.test(val), {
      message: '12 символов 375 (__) ___-__-__',
    }),
  phoneNumber: z.string().trim().optional(),
  email: z
    .string()
    .trim()
    .optional()
    .refine((value) => !value || z.string().email().safeParse(value).success, {
      message: 'Неверный email',
    }),
  enabled: z.boolean(),
  roles: z.array(z.string()).min(1, 'Выберите хотя бы одну роль'),
})

export type UserEditFormData = z.infer<typeof UserEditSchema>

export const payloadSchema = z.object({
  number: z.string().trim().min(1),
  currency: z.string().trim().min(1),
  paymentType: z.string().trim().min(1),
  isActive: z.boolean(),
})
